import styled from "styled-components";

const FormLabelDescription = styled.p`
  display: block;
  max-width: 380px;
  width: 100%;
  margin: 10px auto 20px 0px;
  text-align: left;
  padding-left: 10px;
  color: gray;
  opacity: 0.7;
  font-size: 1.1rem;
  font-family: "Roboto", sans-serif;
`;

export default FormLabelDescription;
